import assertString from './util/assertString';

/* eslint-disable prefer-rest-params */
/**
 * check if the string's length falls in a range
 * @param str the string to evaluate
 * @param options is an object which defaults to { min:0, max: undefined }
 */
export default function isLength(str, options) {
  assertString(str);
  let min;
  let max;
  if (typeof options === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  const surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  const len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
